import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

/** בדיקת מובייל פשוטה */
const isMobile = () => /Android|webOS|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent);

/** אילו שדות חובה בצד לקוח (למקרה שהשרת מחזיר את כל המשתמש) */
const REQUIRED_FIELDS = ['city', 'street', 'region', 'gender', 'email'];

/**
 * אופציות:
 * - endpoint: כתובת ה־API לבדיקת השלמת פרטים.
 *   שתי אפשרויות נתמכות:
 *   1) ה־API מחזיר { complete: boolean }  — קליל.
 *   2) ה־API מחזיר אובייקט משתמש — נבדוק בצד לקוח אם יש חסרים.
 *
 * - profilePath: לאן לנווט לכפתור "עדכון פרטים".
 * - blockAll: לחסום תמיד (גם בדסקטופ) או רק במובייל.
 */
export default function RequiredFieldsGate({
  children,
  endpoint = 'dashboard/member/member_self',        // שנה/י אם יש לך endpoint שמחזיר {complete:true/false}
}) {
  const profilePath = isMobile()?'PapeUserDetails':''
  const [checking, setChecking] = useState(true);
  const [mustComplete, setMustComplete] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  console.log(profilePath)
  useEffect(() => {
    let mounted = true;
    const run = async () => {

      if (location.pathname === `/Mobile/${profilePath}`) {
       setMustComplete(false)
      mounted && setChecking(false);
      return;
    }

      if (!isMobile()&&location.pathname === `/registrationTrainingDays`) {
       setMustComplete(false)
      mounted && setChecking(false);
      return;
    }

      try {
        const res = await axios.get('dashboard/member/check_info_fill' );
        // console.log(res)
        // 🔹 אפשרות 1: השרת מחזיר { complete: boolean }
          console.log(res.data)
        if (!res?.data) {
          
          if (mounted) {
            setMustComplete(!res?.data);
          }
        }
        // 🔹 אפשרות 2: השרת מחזיר משתמש מלא — נבדוק שדות חובה בצד לקוח
        // else if (res?.data && typeof res.data === 'object') {
        //   const user = res.data;
        //   const missing = REQUIRED_FIELDS.filter((k) => !user?.[k] || String(user[k]).trim() === '');
        //   if (mounted) {
        //     setMustComplete(missing.length > 0);
        //   }
        // } 
        else {
            
          // מבנה תשובה לא צפוי — לא נחסום
          if (mounted) setMustComplete(false);
        }
      } catch (e) {
        // שגיאת רשת: כדי לא לתקוע את האפליקציה, לא נחסום.
        if (mounted) setMustComplete(false);
      } finally {
        if (mounted) setChecking(false);
      }
    };

    run();
    return () => { mounted = false; };
  }, [endpoint, location.pathname]);

  // בזמן בדיקה – אפשר להציג ספינר קטן או כלום
  if (checking) return null;

  return (
    <>
      {children}

      { mustComplete &&(
        <div
          aria-modal="true"
          role="dialog"
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
          style={{ pointerEvents: 'auto' }}
        >
          {/* רקע */}
          <div className="absolute inset-0 bg-black/50" />

          {/* קופסה */}
          <div className="relative z-10 max-w-md w-full bg-white rounded-xl shadow-xl p-6 text-right" style={{ direction: 'rtl' }}>
            <h3 className="text-lg font-bold mb-3">שימו/י לב</h3>
            <p className="text-sm leading-6 whitespace-pre-line">
              {`שלום רב!
לצורך המשך הרישום לפעילויות הלשכה
הינך מתבקש/ת להשלים/לעדכן את הפרטים בפרופיל האישי
(יש לעדכן את כל שדות החובה)
תודה,
לשכת ממוני הבטיחות`}
            </p>

            <div className="mt-5 flex justify-start">
              <button
                type="button"
                onClick={() => isMobile()?navigate(profilePath):navigate("/registrationTrainingDays?edit=true")}
                className="rounded-lg bg-blue-600 text-white px-4 py-2 font-semibold hover:bg-blue-700"
              >
                לעדכון פרטים
              </button>
            </div>
          </div>
        </div>
      )}

      {/* חסימת גלילה/קליקים מאחורי המודאל */}
      {mustComplete && (
        <style>{`
          body { overflow: hidden; }
          #root > *:not([aria-modal="true"]) { pointer-events: none !important; }
        `}</style>
      )}
    </>
  );
}
